<template>
  <button class="button">
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'MsButton',
};
</script>

<style>
.button {
  background-color: #4CAF50;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
</style>
